import React from "react";

export function ItemSearch({
  searchTerm,
  onSearchChange,
  activeFilter,
  onFilterChange,
  children // extra toolbar controls (desktop view toggle)
}) {
  return (
    <div className="list-toolbar">
      <div className="search-container">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          className="search-input"
          placeholder="Search items by name, HSN/SAC, or unit..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <div className="filter-pills-row">
        <button
          type="button"
          className={`filter-pill ${activeFilter === "ALL" ? "active" : ""}`}
          onClick={() => onFilterChange("ALL")}
        >
          All Items
        </button>
        <button
          type="button"
          className={`filter-pill ${activeFilter === "GOODS" ? "active" : ""}`}
          onClick={() => onFilterChange("GOODS")}
        >
          📦 Goods
        </button>
        <button
          type="button"
          className={`filter-pill ${activeFilter === "SERVICES" ? "active" : ""}`}
          onClick={() => onFilterChange("SERVICES")}
        >
          ⚙️ Services
        </button>
        <button
          type="button"
          className={`filter-pill ${activeFilter === "LOW_STOCK" ? "active" : ""}`}
          onClick={() => onFilterChange("LOW_STOCK")}
        >
          ⚠️ Low Stock
        </button>
      </div>
      {children}
    </div>
  );
}

export default ItemSearch;
